"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _variables = require("../common/variables.js");

var _uuid = require("uuid");

var _BackgroundColorContext = _interopRequireDefault(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var patternMatch = function patternMatch(pattern, value) {
  return new RegExp(pattern).test(value);
};

var DxcTextarea = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var label = _ref.label,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      value = _ref.value,
      helperText = _ref.helperText,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      _ref$verticalGrow = _ref.verticalGrow,
      verticalGrow = _ref$verticalGrow === void 0 ? "auto" : _ref$verticalGrow,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 4 : _ref$rows,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      error = _ref.error,
      pattern = _ref.pattern,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      _ref$autocomplete = _ref.autocomplete,
      autocomplete = _ref$autocomplete === void 0 ? "off" : _ref$autocomplete,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerValue = _useState2[0],
      setInnerValue = _useState2[1];

  var _useState3 = (0, _react.useState)("textarea-".concat((0, _uuid.v4)())),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
      textareaId = _useState4[0];

  var colorsTheme = (0, _useTheme["default"])();
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var textareaRef = (0, _react.useRef)(null);
  var errorId = "error-".concat(textareaId);

  var isNotOptional = function isNotOptional(value) {
    return value === "" && !optional;
  };

  var isLengthIncorrect = function isLengthIncorrect(value) {
    return value !== "" && minLength && maxLength && (value.length < minLength || value.length > maxLength);
  };

  var changeValue = function changeValue(newValue) {
    value !== null && value !== void 0 ? value : setInnerValue(newValue);
    if (isNotOptional(newValue)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue,
      error: translatedLabels.formFields.requiredValueErrorMessage
    });else if (isLengthIncorrect(newValue)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue,
      error: translatedLabels.formFields.lengthErrorMessage(minLength, maxLength)
    });else if (newValue && pattern && !patternMatch(pattern, newValue)) onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue,
      error: translatedLabels.formFields.formatRequestedErrorMessage
    });else onChange === null || onChange === void 0 ? void 0 : onChange({
      value: newValue
    });
  };

  var handleTOnBlur = function handleTOnBlur(event) {
    if (isNotOptional(event.target.value)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: translatedLabels.formFields.requiredValueErrorMessage
    });else if (isLengthIncorrect(event.target.value)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: translatedLabels.formFields.lengthErrorMessage(minLength, maxLength)
    });else if (event.target.value && pattern && !patternMatch(pattern, event.target.value)) onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value,
      error: translatedLabels.formFields.formatRequestedErrorMessage
    });else onBlur === null || onBlur === void 0 ? void 0 : onBlur({
      value: event.target.value
    });
  };

  var handleTOnChange = function handleTOnChange(event) {
    changeValue(event.target.value);
  };

  (0, _react.useLayoutEffect)(function () {
    if (verticalGrow === "auto") {
      var textareaLineHeight = parseInt(window.getComputedStyle(textareaRef.current)["line-height"]);
      var textareaPaddingTopBottom = parseInt(window.getComputedStyle(textareaRef.current)["padding-top"]) * 2;
      textareaRef.current.style.height = "".concat(textareaLineHeight * rows, "px");
      var newHeight = textareaRef.current.scrollHeight - textareaPaddingTopBottom;
      textareaRef.current.style.height = "".concat(newHeight, "px");
    }
  }, [value, verticalGrow, rows, innerValue]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.textarea
  }, /*#__PURE__*/_react["default"].createElement(TextareaContainer, {
    margin: margin,
    size: size,
    ref: ref
  }, label && /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: textareaId,
    disabled: disabled,
    backgroundType: backgroundType,
    helperText: helperText
  }, label, " ", optional && /*#__PURE__*/_react["default"].createElement(OptionalLabel, null, translatedLabels.formFields.optionalLabel)), helperText && /*#__PURE__*/_react["default"].createElement(HelperText, {
    disabled: disabled,
    backgroundType: backgroundType
  }, helperText), /*#__PURE__*/_react["default"].createElement(Textarea, {
    id: textareaId,
    name: name,
    value: value !== null && value !== void 0 ? value : innerValue,
    placeholder: placeholder,
    verticalGrow: verticalGrow,
    rows: rows,
    onChange: handleTOnChange,
    onBlur: handleTOnBlur,
    disabled: disabled,
    error: error,
    minLength: minLength,
    maxLength: maxLength,
    autoComplete: autocomplete,
    backgroundType: backgroundType,
    ref: textareaRef,
    tabIndex: tabIndex,
    "aria-disabled": disabled,
    "aria-invalid": error ? "true" : "false",
    "aria-errormessage": error ? errorId : undefined,
    "aria-required": optional ? "false" : "true"
  }), !disabled && typeof error === "string" && /*#__PURE__*/_react["default"].createElement(Error, {
    id: errorId,
    backgroundType: backgroundType,
    "aria-live": error ? "assertive" : "off"
  }, error)));
});

var sizes = {
  small: "240px",
  medium: "360px",
  large: "480px",
  fillParent: "100%"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var TextareaContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return calculateWidth(props.margin, props.size);
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  ", "\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledLabelFontColorOnDark : props.theme.disabledLabelFontColor : props.backgroundType === "dark" ? props.theme.labelFontColorOnDark : props.theme.labelFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.labelFontSize;
}, function (props) {
  return props.theme.labelFontStyle;
}, function (props) {
  return props.theme.labelFontWeight;
}, function (props) {
  return props.theme.labelLineHeight;
}, function (props) {
  return !props.helperText && "margin-bottom: 0.25rem";
});

var OptionalLabel = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.optionalLabelFontWeight;
});

var HelperText = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  margin-bottom: 0.25rem;\n"])), function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledHelperTextFontColorOnDark : props.theme.disabledHelperTextFontColor : props.backgroundType === "dark" ? props.theme.helperTextFontColorOnDark : props.theme.helperTextFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.helperTextFontSize;
}, function (props) {
  return props.theme.helperTextFontStyle;
}, function (props) {
  return props.theme.helperTextFontWeight;
}, function (props) {
  return props.theme.helperTextLineHeight;
});

var Textarea = _styledComponents["default"].textarea(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  ", "\n\n  padding: 0.5rem 1rem;\n  box-shadow: 0 0 0 2px transparent;\n  border-radius: 0.25rem;\n  border: 1px solid\n    ", ";\n  ", "\n\n  ", ";\n  ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  line-height: 1.5em;\n\n  ::placeholder {\n    color: ", ";\n  }\n"])), function (props) {
  if (props.verticalGrow === "none") return "resize: none;";else if (props.verticalGrow === "auto") return "resize: none; overflow: hidden;";else if (props.verticalGrow === "manual") return "resize: vertical;";else return "resize: none;";
}, function (props) {
  if (props.disabled) return props.backgroundType === "dark" ? "background-color: ".concat(props.theme.disabledContainerFillColorOnDark, ";") : "background-color: ".concat(props.theme.disabledContainerFillColor, ";");else return "background-color: transparent;";
}, function (props) {
  if (props.disabled) return props.backgroundType === "dark" ? props.theme.disabledBorderColorOnDark : props.theme.disabledBorderColor;else return props.backgroundType === "dark" ? props.theme.enabledBorderColorOnDark : props.theme.enabledBorderColor;
}, function (props) {
  return props.error && !props.disabled && "border-color: transparent;\n     box-shadow: 0 0 0 2px ".concat(props.backgroundType === "dark" ? props.theme.errorBorderColorOnDark : props.theme.errorBorderColor, ";\n  ");
}, function (props) {
  return props.disabled && "cursor: not-allowed;";
}, function (props) {
  return !props.disabled && "\n      &:hover {\n        border-color: ".concat(props.error ? "transparent" : props.backgroundType === "dark" ? props.theme.hoverBorderColorOnDark : props.theme.hoverBorderColor, ";\n        ").concat(props.error && "box-shadow: 0 0 0 2px ".concat(props.backgroundType === "dark" ? props.theme.hoverErrorBorderColorOnDark : props.theme.hoverErrorBorderColor, ";"), "\n      }\n      &:focus {\n        outline: none;\n        border-color: transparent;\n        box-shadow: 0 0 0 2px ").concat(props.backgroundType === "dark" ? props.theme.focusBorderColorOnDark : props.theme.focusBorderColor, ";\n      }\n      &:focus-within {\n        outline: none;\n        border-color: transparent;\n        box-shadow: 0 0 0 2px ").concat(props.backgroundType === "dark" ? props.theme.focusBorderColorOnDark : props.theme.focusBorderColor, ";\n      }\n    ");
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledValueFontColorOnDark : props.theme.disabledValueFontColor : props.backgroundType === "dark" ? props.theme.valueFontColorOnDark : props.theme.valueFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.valueFontSize;
}, function (props) {
  return props.theme.valueFontStyle;
}, function (props) {
  return props.theme.valueFontWeight;
}, function (props) {
  return props.disabled ? props.backgroundType === "dark" ? props.theme.disabledPlaceholderFontColorOnDark : props.theme.disabledPlaceholderFontColor : props.backgroundType === "dark" ? props.theme.placeholderFontColorOnDark : props.theme.placeholderFontColor;
});

var Error = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.75rem;\n  font-weight: 400;\n  min-height: 1.5em;\n  line-height: 1.5em;\n  margin-top: 0.25rem;\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.errorMessageColorOnDark : props.theme.errorMessageColor;
}, function (props) {
  return props.theme.fontFamily;
});

var _default = DxcTextarea;
exports["default"] = _default;